import React from "react";
import { useState } from "react";
import { useAppSelector } from "../../hooks";
import {
  selectDarkmode,
  selectDocuments,
} from "../../states/slices/globalReducer";
import DashboardLayout from "../../shared/Layouts/DashboardLayout";
import {
  PDF_ICON,
  RED_ARROW,
  SMALL_SEARCH,
  SMALL_SEARCH_WHITE,
} from "../../utils-func/image_exports";
import ButtonV2 from "../../shared/components/buttonV2";
import ModalV2 from "../../shared/components/modalV2";
import { useQuery } from "react-query";
import { GetAllDocuments } from "../../services/others/service";
import DocumentView from "../../shared/components/documentView";
import { FaFilePdf } from "react-icons/fa6";

function Document() {
  const darkmode = useAppSelector(selectDarkmode);
  const [pdfUrl, setPdfUrl] = useState("");
  const [pdfName, setPdfName] = useState("");
  const [documentModal, setDocumentModal] = useState(false);
  // const documents = useAppSelector(selectDocuments);
  const { data: documents } = useQuery("documents", GetAllDocuments);

  return (
    <div className="lg:p-10 p-5">
      <div
        className={`flex flex-col gap-y-1 ${
          darkmode ? "border-[#343839]" : ""
        } border-b pb-3 lg:pt-0 pt-8`}
      >
        <span
          className={`lg:text-[40px] text-[20px] font-semibold  ${
            darkmode ? "text-white/80" : "text-black"
          }`}
        >
          Legal Documents
        </span>
        <span className="text-[24px] font-normal text-[#6C7275]">
          List of uploaded documents{" "}
        </span>
      </div>
      {/* <div
        className={`flex items-center lg:w-[360px] w-full my-5 gap-x-2 p-3 border  ${
          darkmode ? "border-[#343839]" : "border-[#E8ECEF]"
        } rounded-3xl`}
      >
        <img
          src={darkmode ? SMALL_SEARCH_WHITE : SMALL_SEARCH}
          className="w-[24px] h-[24px]"
          alt=""
        />
        <input
          type="text"
          placeholder="Search ..."
          className={`text-[17px] placeholder:text-[17px] placeholder:text-[#8A8A8A] font-normal w-full bg-transparent outline-none ${
            darkmode ? "text-white/50" : "text-black"
          }`}
        />
      </div> */}
      {documents?.data?.length > 0 && documents?.data != undefined ? (
        <div className="w-full grid lg:grid-cols-3 grid-cols-1 gap-5 max-h-[600px] mt-7 overflow-y-scroll">
          {documents?.data?.map((urls: any, urlIndex: number) =>
            urls?.file_path.map((url: any, fileIndex: number) => (
              <div
                className={`flex flex-col gap-y-5 w-full items-start border ${
                  darkmode ? "border-[#343839]" : "border-[#E8ECEF]"
                } rounded-lg p-3`}
              >
                <div className="flex items-start gap-x-3">
                  <img src={PDF_ICON} className="w-[40px] h-[40px]" alt="" />
                  <span
                    className={`font-medium text-sm ${
                      darkmode ? "text-white/90" : "text-black"
                    }`}
                  >
                    {`Document Batch ${urlIndex + 1} - File ${fileIndex + 1}`}
                  </span>
                </div>
                <ButtonV2
                  title={"View Legal Document"}
                  image={RED_ARROW}
                  imageSize="w-[14px] h-[14px]"
                  btnStyle={"flex items-center gap-x-2 flex-row-reverse"}
                  textStyle={"text-[#D84C10] text-xs font-medium"}
                  handleClick={() => {
                    setDocumentModal(true);
                    setPdfUrl(url);
                    setPdfName(
                      `Document Batch ${urlIndex + 1} - File ${fileIndex + 1}`
                    );
                  }}
                />
              </div>
            ))
          )}
        </div>
      ) : (
        <div className="flex items-center flex-col gap-y-2 justify-center min-h-[60vh]">
          <FaFilePdf size={40} color="#6C7275" />
          <span className="lg:text-[32px] text-[20px] text-center font-normal text-[#6C7275]">
            Uploaded Documents Would <br /> be Displayed Here
          </span>
        </div>
      )}

      <DocumentView
        pdfUrl={pdfUrl}
        modalOpen={documentModal}
        modalClose={() => setDocumentModal(false)}
        pdfName={pdfName}
      />
    </div>
  );
}

export default Document;
